import { createContext } from 'react';

export const { Consumer: AccordionConsumer, Provider: AccordionProvider } =
  createContext();
